import { Form, Formik } from 'formik'
import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { CampaignContext } from '../../../../../../../../contexts/CampaignContext'
import axiosService from '../../../../../../../../utils/AxiosService'
import Input from '../../../../../../../FormComponents/Input'
import { toastError, toastSuccess } from '../../../../../../../FormComponents/Toasts'
import Modal from '../../../../../../../Modal/Modal'
import * as Yup from 'yup'

const ActionSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
});

export default observer(function EditActionModal({ action, open, setOpen, toggleDropdown }) {
  const { id } = useParams()
  const { primaryScenarioId } = useContext(CampaignContext)

  const editAction = changedAction => {
    axiosService.patch(`/api/project_manager/campaigns/${id}/campaign_scenarios/${primaryScenarioId}/actions/${action.id}`, { campaign_scenario_action: changedAction })
    .then(updatedAction => {
      action.name = updatedAction.name
      toggleDropdown()
      setOpen(false)
      toastSuccess('Action updated')
    })
    .catch(({ data: { error } }) => toastError(error))
  }

  return (
    <Modal isOpen={open} onClose={() => setOpen(false)}>
      <Modal.Header>Edit Action</Modal.Header>
      <Modal.Body>
        <Formik
          validationSchema={ActionSchema}
          initialValues={{ name: action.name }}
          onSubmit={editAction}
        >
          {({ handleBlur, handleChange, values, errors, touched }) => (
            <Form>
              <div className="form-item-container w-full">
                <Input autoFocus error={touched.name && errors.name} placeholder="Name" name='name' onChange={handleChange} onBlur={handleBlur} value={values.name} />
                <button
                  type="submit"
                  className="bg-rb-green text-white px-4 py-2 rounded-2xl w-full mt-4"
                >
                  Update Action
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  )
})